import { render, staticRenderFns } from "./MarkAsDeceasedModal.vue?vue&type=template&id=dc931086&"
import script from "./MarkAsDeceasedModal.vue?vue&type=script&lang=js&"
export * from "./MarkAsDeceasedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports